export default function(pdlId:string, production:boolean){
    return `${production?'kandiboard_pdl_jobads':'kandiboard_dev_pdl_jobads'}_${pdlId.replace(/\.?([A-Z])/g, function (x,y){return "_" + y.toLowerCase()}).replace(/^_/, "")}`
}